/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyPositionInfo,
    JsonCompanyPositionInfoFromJSON,
    JsonCompanyPositionInfoFromJSONTyped,
    JsonCompanyPositionInfoToJSON,
} from './JsonCompanyPositionInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonCompanyPositionInfo
 */
export interface ApiResultOfListOfJsonCompanyPositionInfo {
    /**
     * 
     * @type {Array<JsonCompanyPositionInfo>}
     * @memberof ApiResultOfListOfJsonCompanyPositionInfo
     */
    data?: Array<JsonCompanyPositionInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyPositionInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonCompanyPositionInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyPositionInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyPositionInfo
     */
    result?: ApiResultOfListOfJsonCompanyPositionInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonCompanyPositionInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonCompanyPositionInfoFromJSON(json: any): ApiResultOfListOfJsonCompanyPositionInfo {
    return ApiResultOfListOfJsonCompanyPositionInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonCompanyPositionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonCompanyPositionInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonCompanyPositionInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonCompanyPositionInfoToJSON(value?: ApiResultOfListOfJsonCompanyPositionInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonCompanyPositionInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

